import { SuggestionStatus } from 'types/suggestions/LoadSuggestions';
import { SuggestedQuoteChange } from 'types/suggestions/QuoteSuggestions';

import { HANDLED_STATE_PRECEDENCE } from '../constants';
import { QuoteHandledState } from '../types';

// Load building cards carry their own handledState values, which read as Active here.
export type HandledStateFields = Pick<SuggestedQuoteChange, 'status'> & {
  handledState?: string;
};

/**
 * Combines the backend state with the legacy status field.
 * Accepted maps to Quoted and Rejected maps to Skipped.
 * Unknown or missing backend states map to Active.
 */
export function deriveHandledState(
  suggestion: HandledStateFields
): QuoteHandledState {
  const serverHandledState = parseHandledState(suggestion.handledState);
  const statusDerivedState = getStatusDerivedHandledState(suggestion.status);

  return (
    HANDLED_STATE_PRECEDENCE.find(
      (state) => state === serverHandledState || state === statusDerivedState
    ) ?? QuoteHandledState.Active
  );
}

function parseHandledState(value: unknown): QuoteHandledState {
  const knownStates: unknown[] = Object.values(QuoteHandledState);
  return knownStates.includes(value)
    ? (value as QuoteHandledState)
    : QuoteHandledState.Active;
}

function getStatusDerivedHandledState(
  status: SuggestionStatus
): QuoteHandledState {
  switch (status) {
    case SuggestionStatus.Accepted:
      return QuoteHandledState.Quoted;
    case SuggestionStatus.Rejected:
      return QuoteHandledState.Skipped;
    default:
      // Pending, and InFlight (opened in the form, not quoted yet)
      return QuoteHandledState.Active;
  }
}
